module.exports = __webpack_public_path__ + "static/media/img8.37a9894c.png";